class LightDomSlotFallbackController {
  constructor(host, slots) {
    this.slots = [];
    this.host = host;
    this.slots = slots;
  }
  setFallbackSlotsContent() {
    this.slots.forEach(this.setFallbackSlotContent.bind(this));
  }
  setFallbackSlotContent({ fallbackElement, slotName }) {
    const lightDomIcons = this.host.querySelector?.(`[slot="${slotName}"]`);
    if (!lightDomIcons) {
      fallbackElement.slot = slotName;
      this.host.appendChild(fallbackElement);
    }
  }
}

export { LightDomSlotFallbackController };
